import { Box, Button, Flex, Text } from '@chakra-ui/react'
import type { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { FormProvider, useForm } from 'BrokerTsLib/src/rhf'
import { useInsuranceParams } from '../context/InsuranceParamsProvider'
import { useSelectedQuote } from '../context/SelectedQuoteContext'

import { usePartner } from '@/context/PartnerContext'
import { InputFormControl } from 'BrokerTsLib/src/components'


interface AddVehcleInfoFormProps {
  onSubmit: (values: AddVehicleInfoFormValues) => Promise<any>
}

export interface AddVehicleInfoFormValues {
  vin: string | null
  registration?: string | null
  tpNumber?: string | null
  orvNumber?: string | null
}

export const AddVehicleInfoForm = ({ onSubmit }: AddVehcleInfoFormProps) => {

  const { currentPartner } = usePartner()
  const { insuranceParams } = useInsuranceParams()
  const vehicle = (insuranceParams as InsuranceParamsDto).vehicle
  const methods = useForm<AddVehicleInfoFormValues>({
    defaultValues: {
      vin: vehicle.vin,
      registration: vehicle.licensePlate,
      tpNumber: vehicle.cisloTechnickehoPrukazu,
      orvNumber: vehicle.cisloOrv
    },
  })

  const { handleSubmit, control, formState: { isSubmitting }, watch } = methods

  const handleFormSubmit = (values: AddVehicleInfoFormValues) => {
    return onSubmit(values)
  }

  const { offer } = useSelectedQuote()
  const isNewUniqa = (offer?.insurerId ?? 0) === 1 && currentPartner?.partner != 'Jap'
  const orvDisabled = false

  const registration = watch('registration')
  const tpNumber = watch('tpNumber')
  const orvNumber = watch('orvNumber')
  const isTpRequired = !!registration && !orvNumber
  const isOrvRequired = !!registration && !tpNumber

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <Box sx={{ display: 'grid', gap: 4, justifyItems: 'stretch' }}>
          <InputFormControl control={control} name="vin" label="VIN" isDisabled />

          <InputFormControl control={control} name="registration" label="Registrační značka (SPZ)" />

          <InputFormControl control={control} name="tpNumber" label="Číslo velkého technického průkazu" isRequired={isTpRequired} />

          <InputFormControl control={control} name="orvNumber" label="Číslo ORV" isDisabled={orvDisabled} isRequired={isOrvRequired} />

          <Flex mt={4} justifyContent='center'>
            {!isNewUniqa &&
              <Button
                type="submit"
                variant="solid"
                colorScheme="primary"
                isLoading={isSubmitting}
                disabled={isSubmitting}
              >
                Uložit
              </Button>
            }

            {isNewUniqa &&
              <Box>
                <Text variant='error'>
                  Doplnění údajů máte bez práce. UNIQA pojišťovna, a.s. si údaje automaticky načítá z ČKP po řádném zaplacení a vzniku smlouvy.
                </Text>
              </Box>
            }
          </Flex>
        </Box>
      </form>
    </FormProvider>
  )
}
